import type { FC, PropsWithChildren } from "react";
import { StyledMenuButton } from "./styled";
type MobileNavigationMenuButtonProps = {
  onClick: () => void;
};
export const MobileNavigationMenuButton: FC<
  PropsWithChildren<MobileNavigationMenuButtonProps>
> = ({ children, onClick }) => (
  <StyledMenuButton onClick={onClick}>{children}</StyledMenuButton>
);
